import { Controller } from "@hotwired/stimulus";

/**
 * Shows one sheet of a preview at a time, with « previous » and « next »
 * and a counter (29/10/2026: the honor roll sheets of a « Générer » page).
 *
 * <div data-controller="sheet-pager">
 *   <button data-sheet-pager-target="previous" data-action="sheet-pager#previous">←</button>
 *   <span data-sheet-pager-target="counter"></span>
 *   <button data-sheet-pager-target="next" data-action="sheet-pager#next">→</button>
 *   <article data-sheet-pager-target="sheet">…</article>
 *   <article data-sheet-pager-target="sheet" hidden>…</article>
 */
export default class extends Controller {
  static targets = ["sheet", "counter", "previous", "next"];
  static values = { index: { type: Number, default: 0 }, label: { type: String, default: "%{index} / %{total}" } };

  connect() {
    this.show();
  }

  previous() {
    this.indexValue = Math.max(0, this.indexValue - 1);
    this.show();
  }

  next() {
    this.indexValue = Math.min(this.sheetTargets.length - 1, this.indexValue + 1);
    this.show();
  }

  show() {
    const total = this.sheetTargets.length;
    this.sheetTargets.forEach((sheet, index) => {
      sheet.hidden = index !== this.indexValue;
    });
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = this.labelValue
        .replace("%{index}", String(this.indexValue + 1))
        .replace("%{total}", String(total));
    }
    if (this.hasPreviousTarget) this.previousTarget.disabled = this.indexValue <= 0;
    if (this.hasNextTarget) this.nextTarget.disabled = this.indexValue >= total - 1;
  }
}
